import { makeStyles } from '@material-ui/core'
import React from 'react'

export const SectionTitle = ({ title }) => {
    const styles = useStyles()
    return <h3 className={styles.title}>{title}</h3>
}

const useStyles = makeStyles(() => ({
    title: {
        marginBottom: 4
    }
}))
